export const defaultParametersDocumentCPU = {
	// those values may be later modified via loading parameters

	// player basic

	// @public
	// @type boolean
	playStopOthers : true,
	// @public
	// @type boolean
	scrollTo : false,
	// @public
	// @type boolean
	autoplay : false,
	// @public
	// @type string
	IDPrefix: 'CPU-Audio-tag-',

	// interface building

	// @public
	// @type boolean
	globalCss : true,

	// playlist interactions

	// @public
	// @type boolean
	advanceInPlaylist : true,

	// Keyboard navigation

	// @public
	// @type number
	keymove : 5,

	// Precise navigation with fingers

	// @public
	// @type number
	alternateDelay : 1000,
	// @public
	// @type number
	fastFactor : 4,
	// @public
	// @type number
	repeatDelay : 400,
	// @public
	// @type number
	repeatFactor : 100,

};

export default defaultParametersDocumentCPU;